(() => {
  'use strict';
  const selectors = '.mobile-navigation, .search-panel, .desktop-submenu';
  function closeOthers(except) {
    document.querySelectorAll(selectors).forEach(panel => {
      if (panel !== except) panel.removeAttribute('open');
    });
  }
  document.addEventListener('toggle', event => {
    if (event.target.matches?.(selectors) && event.target.open) closeOthers(event.target);
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll(selectors).forEach(panel => {
      if (panel.open && !panel.contains(event.target)) panel.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const activePanel = document.activeElement?.closest(selectors);
      closeOthers();
      activePanel?.querySelector('summary')?.focus();
    }
    if (event.key !== 'Tab') return;
    const panel = document.querySelector('.mobile-navigation[open], .search-panel[open]');
    if (!panel || !panel.contains(document.activeElement)) return;
    const items = Array.from(panel.querySelectorAll('summary, a[href], button, input, select')).filter(el => el.getClientRects().length && !el.disabled);
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('shopify:section:unload', () => closeOthers());
})();
